import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ClearOutlined from '@mui/icons-material/ClearOutlined';

export type ButtonResetIconProps = {
  handleReset: () => void;
  isDropDownSelect?: boolean;
};

function ButtonResetIcon({ handleReset, isDropDownSelect }: ButtonResetIconProps) {
  const theme = useTheme();
  return (
    <IconButton
      component='div'
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        handleReset();
      }}
      sx={{ maxHeight: '15px', maxWidth: '15px', marginLeft: '4px', marginRight: '4px' }}
      data-testid='filter-button-reset'
    >
      <ClearOutlined
        sx={{
          color: isDropDownSelect ? theme.palette.secondary.main : theme.palette.primary.main,
          fontSize: 'medium',
          alignSelf: 'center',
        }}
        fontSize='inherit'
      />
    </IconButton>
  );
}

ButtonResetIcon.defaultProps = {
  isDropDownSelect: false,
};

export default ButtonResetIcon;
